<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <div v-if="!isMain" :class="[getClassName + 'CheckBox']">
      <input
        :id="'checkbox-pp-' + ppcode"
        type="checkbox"
        :checked="isEnabled"
        :value="ppcode"
        @change="check($event)"
      />
      <label :for="'checkbox-pp-' + ppcode"></label>
    </div>
    <div class="matrix_tableHeader" @click="clickPPName">
      {{ name }}
    </div>
    <div
      v-if="isEnabled"
      class="matrix_productPartsNamesBundleInfo"
      :class="getIsCompleteClass"
    >
      <appAwesomeIcon v-if="isComplete" icon="check" />
      <appAwesomeIcon v-if="!isComplete" icon="exclamation" />
    </div>
  </div>
</template>
<script>
import { useBundleStore } from "@/stores/modules/bundle";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    code: function () {
      return this.ppcode;
    },
    name: function () {
      return this.propsData.name;
    },
    isEnabled: function () {
      return this.propsData.isEnabled;
    },
    isMain: function () {
      return this.propsData.isMain;
    },
    isComplete: function () {
      return this.propsData.isComplete;
    },
    getIsCompleteClass: function () {
      return this.isComplete
        ? "matrix_productPartsNamesBundleOk"
        : "matrix_productPartsNamesBundleInvalid";
    }
  },

  methods: {
    ...mapActions(useBundleStore, ["setBundleCheckPP", "setBundleOpenPP"]),
    activeClass: function () {
      return this.propsData.isEnabled ? "active" : "";
    },
    check: function (e) {
      this.setBundleCheckPP({ ppcode: this.ppcode, checked: e.target.checked });
    },
    clickPPName: function (e) {
      if (!this.isEnabled) {
        return;
      }
      this.setBundleOpenPP(this.ppcode);
    }
  },

  props: ["ppcode", "propsData"]
};
</script>
